(() => {
  let activeField = null;
  let popover = null;
  let scheduled = 0;
  let invalidBatchActive = false;

  function isVisible(field) {
    return field instanceof HTMLElement &&
      field.getClientRects().length > 0 &&
      getComputedStyle(field).visibility !== 'hidden';
  }

  function getAnchor(field) {
    if (field.type === 'checkbox' || field.type === 'radio') {
      return field.closest('label, .field, fieldset') || field;
    }
    return field;
  }

  function ensurePopover() {
    if (popover) return popover;
    popover = document.createElement('div');
    popover.id = 'quive-form-validation-message';
    popover.className = 'quive-validation-popover';
    popover.setAttribute('role', 'alert');
    popover.setAttribute('aria-hidden', 'true');
    popover.innerHTML = '<span class="quive-validation-popover__mark" aria-hidden="true"></span><span class="quive-validation-popover__text"></span>';
    document.body.appendChild(popover);
    return popover;
  }

  function placePopover() {
    if (!activeField || !popover || !isVisible(activeField)) return;
    const rect = getAnchor(activeField).getBoundingClientRect();
    const viewportWidth = window.innerWidth;
    const viewportHeight = window.innerHeight;
    const width = Math.min(360, Math.max(240, rect.width), viewportWidth - 24);
    popover.style.width = width + 'px';
    const left = Math.min(Math.max(12, rect.left), viewportWidth - width - 12);
    const height = popover.offsetHeight;
    let top = rect.bottom + 12;
    const above = top + height > viewportHeight - 12 && rect.top - height - 12 >= 12;
    if (above) top = rect.top - height - 12;
    if (top + height > viewportHeight - 12) top = Math.max(12, viewportHeight - height - 12);
    popover.style.left = left + 'px';
    popover.style.top = top + 'px';
    popover.classList.toggle('quive-validation-popover--above', above);
  }

  function removeDescription(field) {
    if (!field) return;
    const ids = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    const remaining = ids.filter((id) => id !== 'quive-form-validation-message');
    if (remaining.length) field.setAttribute('aria-describedby', remaining.join(' '));
    else field.removeAttribute('aria-describedby');
    field.classList.remove('quive-field-invalid');
  }

  function dismiss() {
    cancelAnimationFrame(scheduled);
    removeDescription(activeField);
    activeField = null;
    if (popover) {
      popover.classList.remove('is-visible');
      popover.setAttribute('aria-hidden', 'true');
    }
  }

  function show(field) {
    if (activeField !== field) removeDescription(activeField);
    activeField = field;
    const note = ensurePopover();
    note.querySelector('.quive-validation-popover__text').textContent = field.validationMessage;
    const ids = (field.getAttribute('aria-describedby') || '').split(/\s+/).filter(Boolean);
    if (!ids.includes(note.id)) field.setAttribute('aria-describedby', ids.concat(note.id).join(' '));
    field.classList.add('quive-field-invalid');
    note.setAttribute('aria-hidden', 'false');
    note.classList.add('is-visible');
    scheduled = requestAnimationFrame(() => {
      if (activeField !== field) return;
      field.focus({ preventScroll: false });
      field.scrollIntoView({ block: 'center', inline: 'nearest' });
      scheduled = requestAnimationFrame(placePopover);
    });
  }

  document.addEventListener('invalid', (event) => {
    const field = event.target;
    if (!isVisible(field) || !field.willValidate) return;
    event.preventDefault();
    if (invalidBatchActive) return;
    invalidBatchActive = true;
    setTimeout(() => { invalidBatchActive = false; }, 0);
    show(field);
  }, true);

  document.addEventListener('input', (event) => {
    if (event.target === activeField) dismiss();
  }, true);
  document.addEventListener('change', (event) => {
    if (event.target === activeField) dismiss();
  }, true);
  document.addEventListener('reset', dismiss, true);
  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') dismiss();
  }, true);
  document.addEventListener('pointerdown', (event) => {
    if (activeField && event.target !== activeField && !getAnchor(activeField).contains(event.target)) dismiss();
  }, true);
  window.addEventListener('scroll', placePopover, { passive: true, capture: true });
  window.addEventListener('resize', placePopover, { passive: true });
  window.visualViewport?.addEventListener('resize', placePopover, { passive: true });
})();
